import React from 'react';
import {connect} from "react-redux";
import CustomPaper from "../../shared/utils/CustomPaper";
import Divider from 'material-ui/Divider';
import Block1 from "./indexBlocks/Block1";
import Block2 from "./indexBlocks/Block2";
import Block3 from "./indexBlocks/Block3";
class IndexBody extends React.Component {

    render() {
        const e = this.props.entreprise;
        return (
            <div className={'container'} style={{fontSize:12}}>
                <CustomPaper title={'Bienvenu dans votre espace entreprise'}>
                    <Block1 entreprise ={e}/>
                    <Divider/>
                    <Block2 salaries_ajoutes={e.salaries_ajoutes} salaries_max={e.salaries_max} />
                    <Divider/>
                    <Block3/>
                </CustomPaper>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {
        entreprise : store.entreprise.entreprise_infos,
    }
}

export default connect(mapStateToProps)(IndexBody);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/IndexBody.js